import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_URL } from '../config';

export default function SSOLogin() {
  const [searchParams] = useSearchParams();
  const ticket = searchParams.get('ticket');
  const navigate = useNavigate();
  const { login } = useAuth(); // Assuming login context function exists, or we just set localStorage

  useEffect(() => {
    if (!ticket) {
      navigate('/login');
      return;
    }

    const verifyTicket = async () => {
      try {
        const res = await fetch(`${API_URL}/sso/verify-and-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ticket })
        });
        
        if (res.ok) {
          const data = await res.json();
          // Store token and user data
          localStorage.setItem('token', data.token);
          localStorage.setItem('role', data.user.role);
          // Wait a moment and redirect to dashboard
          setTimeout(() => {
             window.location.href = '/'; 
          }, 1000);
        } else {
          console.error('SSO verification failed');
          navigate('/login');
        }
      } catch (err) {
        console.error('SSO connection error:', err);
        navigate('/login');
      }
    };

    verifyTicket();
  }, [ticket, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center">
      <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-4"></div>
      <h2 className="text-xl font-semibold text-slate-800">正在进行跨系统身份验证...</h2>
      <p className="text-slate-500 mt-2">请稍候，正在带您进入系统</p>
    </div>
  );
}
